import Header from "components/header";
import Menu from "components/menu";
import useMediaQuery from "hooks/useMediaQuery";
import HeroBlock from "./block/hero";
import DATA from 'utils/data.json';
import './App.scss';
import What from "block/what";
import Who from "block/who";
import Ready from "block/ready";
import Why from "block/why";
import Teacher from "block/teacher";
import Course from "block/course";
import Testimonial from "block/testimonial";
import Achievement from "block/achievement";
import Partner from "block/partner";
import Qna from "block/qna";
import Register from "block/register";
import Footer from "components/footer";


function App() {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <div className="App" style={isMobile ? {paddingBottom: 50} : {}}>
      {isMobile ? <Menu/> : <Header />}
      <HeroBlock />
      <What />
      <Who />
      <Ready />
      <Why />
      <Teacher />
      <Course />
      <Testimonial />
      <Achievement />
      <Partner />
      <Qna />
      <Register />
      <Footer />
      {isMobile && <a href={DATA['form']} rel="noreferrer" target='_blank' className="fixed-button">Đăng ký ngay</a>}
    </div>
  );
}

export default App;
